module.exports = __webpack_public_path__ + "static/img/card_swiper02.48efcc1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/card_swiper02.svg
// module id = 8FcC
// module chunks = 0